export const iconFontAwesomeDevicesHardwareComputerMouse = (
	<i className="fa-solid fa-computer-mouse"></i>
);
